import { memo } from 'react'
import * as Styled from './styled'
import { ISidebarItemProps } from './types'
import { Text } from 'common-components'

const SidebarItem: React.FC<ISidebarItemProps> = ({
  icon,
  label,
  isActive
}) => (
  <Styled.SidebarItem $isActive={isActive}>
    {icon}
    <Text
      type="h6"
      color={isActive ? 'secondaryDark' : 'secondarySemiDark'}
      fontWeight="500"
    >
      {label}
    </Text>
  </Styled.SidebarItem>
)

export default memo(SidebarItem)
